import React from 'react';
import { Editor as MonacoEditor } from '@monaco-editor/react';
import _ from 'lodash';

type CodeEditorProps = {
  language?: string,
  width?: string,
  height?: string,
  onChange?: (value: string) => void,
  value: string
};

export const CodeEditor: React.FC<CodeEditorProps> = ({
  language = 'javascript',
  width = '100%',
  height = '650px',
  onChange,
  value,
  options = {},
  disabled = false
}) => {
  const handleChange = _.debounce((value: string) => {
    if (onChange) {
      onChange(value);
    }
  }, 1000);
  const editorClassName = disabled ? 'disabled-editor' : '';

  return (
    <div style={{ width, height }}>
      <MonacoEditor
        theme="vs-dark"
        language={language}
        width={width}
        height={height}
        value={value}
        options={{
          ...options,
          selectOnLineNumbers: true,
          formatOnType: true,
          automaticLayout: true,
          scrollBeyondLastLine: false,
        }}
        onChange={handleChange}
        className={editorClassName}
      />
    </div>
  );
};
